import React from "react";

const Perrolobomarino = () => {
  // Arreglos dinámicos para las 20 fotos y 9 videos
  const photos = Array.from(
    { length: 20 },
    (_, i) => `/Perrolobomarino/perrolobomarino (${i + 1}).jpg`,
  );

  const videos = Array.from(
    { length: 9 },
    (_, i) => `/Perrolobomarino/perrolobomarinovideo (${i + 1}).mp4`,
  );

  return (
    <>
      <section id="suelosDelSur">
        <h2>Perrolobomarino</h2>
        <div className="container-fluid overflow-hidden">
          {/* BLOQUE INICIAL: Texto entrelazado con fotos y la imagen principal */}
          <div className="row align-items-center mb-5">
            <div className="col-md-8 d-flex flex-column justify-content-center">
              <p className="ps-md-5 text-center text-md-start fs-4 mb-4">
                Llegué a La Zona con un duelo y un perrolobomarino que me visitó
                en un sueño. Las arcillas silvestres locales dieron forma y
                materia a este bestiario onírico, lo hicieron tangible.
              </p>
            </div>
            <div className="col-md-1 text-center my-3 my-md-0"> </div>
            <div className="col-md-3 text-center my-3 my-md-0">
              <img
                className="img-fluid shadow-sm"
                src={photos[4]}
                alt="detalle arcilla"
                style={{
                  borderRadius: "25px",
                  objectFit: "cover",
                  maxHeight: "auto",
                  width: "100%",
                }}
              />
            </div>
          </div>

          <div className="row align-items-center mb-5">
            <div className="col-md-5 text-center my-3 my-md-0">
              <img
                className="img-fluid shadow-sm"
                src={photos[1]} // Usamos la foto 3
                alt="proceso de obra"
                style={{
                  borderRadius: "25px",
                }}
              />
            </div>
            <div className="col-md-7 d-flex flex-column justify-content-center">
              <p className="ps-md-5 text-center text-md-start fs-4 mb-0">
                Las piezas están atravesadas por el dolor, la tristeza, la
                desesperación, la nostalgia y los recuerdos. Son una manera de
                despedirse, de poder decir adiós, y a la vez de atesorar para
                siempre lo que ya no está.
              </p>
            </div>
          </div>

          {/* FOTO PRINCIPAL DESTACADA (Foto 1) */}
          <div className="row justify-content-center my-5">
            <div className="col-md-6 text-center">
              <img
                className="img-fluid shadow"
                src={photos[3]}
                alt="Perrolobomarino principal"
                style={{ borderRadius: "" }}
              />
            </div>
          </div>

          {/* TEXTO RITUAL */}
          <div className="row align-items-center my-5">
            <div className="col-12 p-md-5">
              <p className="text-center fs-4 mb-4">
                El fuego de ese pozo donde se enterraron se vuelve un ritual.
                Allí se transformaron y luego emergieron como totems o
                talismanes. En el proceso hay una constante relación entre el
                agua y el fuego.
              </p>
              <p className="text-center fs-4">
                Las tanzas y anzuelos que recuperé de la playa, en interacción
                con las cerámicas, refuerzan el sentimiento de muerte.
              </p>
            </div>
          </div>

          {/* SECCIÓN DE VIDEOS (Orden personalizado: 6, 8, 1, 7, 2, 9, 3, 5, 4) */}
          <div className="my-5">
            <h3 className="text-center mb-4 fs-4 text-muted">
              Registros en Movimiento
            </h3>
            <div className="row g-3">
              {[6, 8, 1, 7, 2, 9, 3, 5, 4].map((videoNum, idx) => (
                <div
                  key={`custom-vid-${idx}`}
                  className="col-12 col-md-6 col-lg-4"
                >
                  <video
                    className="w-100 shadow-sm"
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="auto"
                    style={{
                      borderRadius: "20px",
                      maxHeight: "380px",
                      objectFit: "cover",
                    }}
                  >
                    <source
                      src={`/Perrolobomarino/perrolobomarinovideo (${videoNum}).mp4`}
                      type="video/mp4"
                    />
                    Tu navegador no soporta el formato de video.
                  </video>
                </div>
              ))}
            </div>
          </div>

          {/* GALERÍA DE FOTOS RESTANTES (Desde la foto 4 en adelante) */}
          {/* GALERÍA DE FOTOS (Orden personalizado: 6, 3, 1, 18, 19, 7, 13, 9, 14, 8, 15, 12, 20, 16, 10) */}
          <div className="my-5">
            <h3 className="text-center mb-4 fs-4 text-muted">
              Galería y Detalles
            </h3>
            <div className="row g-3">
              {[19, 18, 7, 6, 13, 9, 14, 8, 15, 12, 20, 16].map(
                (photoNum, idx) => (
                  <div
                    key={`custom-img-${idx}`}
                    className="col-12 col-sm-6 col-md-4 col-lg-3"
                  >
                    <img
                      className="img-fluid w-100 shadow-sm"
                      src={`/Perrolobomarino/perrolobomarino (${photoNum}).jpg`}
                      alt={`Registro Perrolobomarino ${photoNum}`}
                      style={{
                        objectFit: "cover",
                        aspectRatio: "1 / 1",
                        borderRadius: "15px",
                      }}
                      loading="lazy"
                    />
                  </div>
                ),
              )}
            </div>
          </div>

          {/* CRÉDITOS */}
          <div className="row">
            <div className="col-12">
              <p className="p-md-3 text-center fs-5">
                Proyecto realizado durante la residencia de invierno veinte
                veintiseis en La Zona, El Marquesado, Mar del plata.
                <br /> <br />
                *Registros por: Sabina Zamudio y Romina Elvira.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Perrolobomarino;
